import { useUser } from "@hooks/useUser";
import { ModuleCard } from "./ModuleCard";

import { modules } from "./const";
import { modulesMapper } from "@helpers/modulesMapper";
import { useUserManualList } from "@hooks/HRM/settings/useUserManualList";
import {
  UserManualResponseType,
  UserManualType,
} from "@type/HRM/settings/user-manual";
import { useEffect, useState } from "react";

interface ModuleCardsPropType {
  handleModuleSelection: (module: string) => void;
}

export function ModuleCards({ handleModuleSelection }: ModuleCardsPropType) {
  const [filteredModules, setFilteredModules] = useState<any[]>([]);

  const { user } = useUser();

  const { realm_roles: roles } = user || {};

  const { userManualState } = useUserManualList();

  const { getData } = userManualState || ({} as UserManualResponseType);
  const { data } = getData || ({} as UserManualType);

  useEffect(() => {
    const modulesWithData = modules.map((module: any) => {
      const matchingData = data?.find(
        (item: any) => item.moduleType === module.value,
      );
      if (matchingData) {
        return {
          ...module,
          document: matchingData.document,
        };
      } else {
        return { ...module, document: null };
      }
    });
    setFilteredModules(modulesWithData);
  }, [data]);

  return (
    <div className="row pt-16">
      {modulesMapper(filteredModules, roles).map(
        ({ label, icon, document, bgImage, value }, _idx) => (
          <div
            key={_idx}
            className="col-lg-6 col-xl-4 g-10 py-2"
            onClick={() => handleModuleSelection(value)}
          >
            <ModuleCard
              document={document}
              id={_idx}
              name={label}
              icon={icon}
              bgImage={bgImage}
            />
          </div>
        ),
      )}
    </div>
  );
}
